export const getTooltipPosition = (window: any) => (window.innerWidth > 1200 ? "right-start" : "bottom");

export const getRightStartOrTopTooltipPosition = (window: any) => (window.innerWidth > 1200 ? "right-start" : "top");
